import React, { useRef, useEffect } from "react";
import {
    Field as FormikControl,
    Form,
    FormikProvider,
    useFormik,
} from "formik";
import "./NoteDropdown.scss";
import { Field } from "@design-system/Field/Field";
import { TextArea } from "@design-system/TextArea/TextArea";
import { Button } from "@design-system/Button/Button";
import { useBulkActions } from "@components/transactions/TransactionsBulkActions/useBulkActions";
import styles from "./NoteDropdown.module.scss";

interface NoteDropdownProps {
    inputPlaceholder: string;
    onSubmitCallback?: () => void;
}

interface FormSchema {
    value: string;
}

export const NoteAction: React.FC<NoteDropdownProps> = ({
    inputPlaceholder,
    onSubmitCallback,
}) => {
    const bulkActions = useBulkActions();
    const textareaRef = useRef<HTMLTextAreaElement>(null);

    const formik = useFormik<FormSchema>({
        initialValues: {
            value: "",
        },
        onSubmit({ value }) {
            bulkActions.updateSelected({
                update: "memo",
                value,
            });
            onSubmitCallback?.();
        },
    });

    // Auto-focus the textarea when component mounts
    useEffect(() => {
        if (textareaRef.current) {
            textareaRef.current.focus();
        }
    }, []);

    // Handle Enter key to submit form
    const handleKeyDown = (event: React.KeyboardEvent<HTMLTextAreaElement>) => {
        if (event.key === "Enter" && !event.shiftKey) {
            event.preventDefault();
            formik.submitForm();
        }
    };

    return (
        <FormikProvider value={formik}>
            <div className={styles.noteAction}>
                <Form>
                    <Field.Root>
                        <FormikControl
                            as={TextArea}
                            name="value"
                            size="xl"
                            className={styles.noteTextarea}
                            placeholder={inputPlaceholder}
                            ref={textareaRef}
                            onKeyDown={handleKeyDown}
                        />
                    </Field.Root>

                    <div className={styles.footer}>
                        <Button type="submit" variant="secondary" size="sm">
                            Submit
                        </Button>
                    </div>
                </Form>
            </div>
        </FormikProvider>
    );
};
